import React from "react";
import { Button, Drawer, Typography } from "@arco-design/web-react";
import FilterBuilder, { FilterCounts } from "./FilterBuilder";
import { emptyFilter, forServer, isTermComplete } from "./contactFilter";

const { Text } = Typography;

// FilterDrawer edits a copy of the filter, with live counts; Apply hands back
// the finished rules (unfinished ones are dropped), Clear all empties it.
export default function FilterDrawer({ visible, value, searchTerm, options, onApply, onClose }) {
  const [draft, setDraft] = React.useState(value || emptyFilter());
  React.useEffect(() => {
    if (visible) setDraft(value && value.groups && value.groups.length ? value : emptyFilter());
  }, [visible, value]);

  const unfinished = draft.groups.some((g) => g.terms.some((t) => !isTermComplete(t, options.customFieldDefs)));

  return (
    <Drawer
      width={640}
      title="Filters"
      visible={visible}
      onCancel={onClose}
      footer={
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {visible && <FilterCounts filter={draft} searchTerm={searchTerm} customFieldDefs={options.customFieldDefs} />}
          <div style={{ flex: 1 }} />
          <Button onClick={() => setDraft(emptyFilter())}>Clear all</Button>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" onClick={() => onApply(forServer(draft, options.customFieldDefs))}>Apply</Button>
        </div>
      }
    >
      <FilterBuilder value={draft} onChange={setDraft} options={options} />
      {unfinished && (
        <Text type="secondary" style={{ display: "block", marginTop: 8, fontSize: 12 }}>
          Rules that aren't finished yet are left out.
        </Text>
      )}
    </Drawer>
  );
}
